import { useState, useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import LoginPage from "@/pages/LoginPage";
import AdminDashboard from "@/pages/AdminDashboard";
import StoreDashboardWrapper from "@/pages/StoreDashboardWrapper";
import PrintPage from "@/pages/PrintPage";

const ProtectedRoute = ({ children, allowedRoles }) => {
  const token = localStorage.getItem("token");
  const user = JSON.parse(localStorage.getItem("user") || "{}");

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  if (allowedRoles && !allowedRoles.includes(user.role)) {
    return <Navigate to="/" replace />;
  }

  return children;
};

const RoleBasedRedirect = () => {
  const user = JSON.parse(localStorage.getItem("user") || "{}");

  if (user.role === "admin") return <Navigate to="/admin" replace />;
  if (user.role === "store") return <Navigate to="/store" replace />;

  return <Navigate to="/login" replace />;
};

function App() {
  useEffect(() => {
    // 数量などの number 入力欄で、フォーカス中のスクロール誤操作により
    // 値が意図せず変わる（例: 1 や 5.02 → 0.02）事故を防止する。
    const onWheel = () => {
      const el = document.activeElement;
      if (el && el.tagName === "INPUT" && el.type === "number") {
        el.blur();
      }
    };
    document.addEventListener("wheel", onWheel, { passive: true });
    return () => document.removeEventListener("wheel", onWheel);
  }, []);
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/" element={<RoleBasedRedirect />} />
          <Route
            path="/admin/*"
            element={
              <ProtectedRoute allowedRoles={["admin"]}>
                <AdminDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/store/*"
            element={
              <ProtectedRoute allowedRoles={["store"]}>
                <StoreDashboardWrapper />
              </ProtectedRoute>
            }
          />
          <Route
            path="/print/:type"
            element={
              <ProtectedRoute allowedRoles={["admin"]}>
                <PrintPage />
              </ProtectedRoute>
            }
          />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" />
    </div>
  );
}

export default App;
